import { type V1UserApiModel } from '@webapp/platform/iam/data-access/api-models/V1UserApiModel'
import { type V1UserConstructor } from '@webapp/platform/iam/entities/V1User'

export const mapV1UserApiModel = (user: V1UserApiModel): V1UserConstructor => ({
  id: user.id,
  authId: user.user,
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  position: user.position,
  phone: user.phone,
  profileImage: user.profile_image,
  slackUserId: user.slack_user_id === '' ? null : user.slack_user_id,
})
